import styled from 'styled-components'
import {Box} from '@primer/components'
import {
  background,
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat
} from 'styled-system'

const BgImage = styled(Box)`
${background}
${backgroundImage}
${backgroundSize}
${backgroundPosition}
${backgroundRepeat}
`
export default BgImage
